import { ComboBox, IComboBoxOption, Label, MaskedTextField, Stack } from '@fluentui/react';
import { useEffect, useState } from 'react';

import { store, useAppSelector } from '../../../../App/store';
import { actions } from '../../slice';
import phoneCodes from './phone-codes.json';

const PhoneInputTextField = (props: { variable: string }) => {
  const variableName = props.variable + "Number";
  const stateNumber = useAppSelector(
    (state) => state.accounts.accountVariables[variableName]
  );
  const [error, setError] = useState<string>();
  const [value, setValue] = useState<string>();

  useEffect(() => {
    if (stateNumber) setValue(stateNumber);
  }, [stateNumber, setValue]);

  return (
    <MaskedTextField
      mask="(999) 999 9999"
      onBlur={() => {
        if (!value) return;

        const hasNumber = /\d/.test(value);
        const hasUnderscore = /\_/.test(value);
        let payloadValue;

        if (hasNumber && hasUnderscore) {
          setError("Geçersiz numara");
          payloadValue = null;
        } else {
          setError(undefined);
          payloadValue = value;
        }

        actions.setAccountVariable([variableName, payloadValue]);
      }}
      onChange={(_, nv) => {
        if (typeof nv === "string") {
          while (nv.startsWith("(0")) {
            nv = nv.replace("(0", "(");
          }

          setValue(nv);
        }
      }}
      value={value}
      errorMessage={error}
    />
  );
};

export const PhoneInput = (props: { label: string; variable: string }) => {
  const variableName = props.variable + "CountryCode";
  const storeCountryCode =
    store.getState().accounts.accountVariables[variableName];
  const storeCountryCodeInfo =
    storeCountryCode &&
    phoneCodes.find((codeInfo) => codeInfo.dial_code === storeCountryCode);

  useEffect(() => {
    actions.setAccountVariable([
      props.variable + "CountryCode",
      defaultCountryCodeInfo.dial_code,
    ]);
  }, []);

  return (
    <Stack>
      <form autoComplete="off">
        <Label>{props.label}</Label>
        <Stack horizontal tokens={{ childrenGap: -2 }}>
          <Stack.Item styles={smallWidthStyle}>
            <ComboBox
              options={dropdownOptions}
              defaultSelectedKey={
                storeCountryCodeInfo
                  ? storeCountryCodeInfo.code
                  : defaultCountryCodeInfo.code
              }
              styles={comboBoxStyle}
              autoComplete="off"
              onChange={(_, no) => {
                const code = no ? no.data?.dial_code : null;

                actions.setAccountVariable([variableName, code]);
              }}
            />
          </Stack.Item>
          <Stack.Item styles={bigWidthStyle}>
            <PhoneInputTextField variable={props.variable} />
          </Stack.Item>
        </Stack>
      </form>
    </Stack>
  );
};

const comboBoxStyle = { callout: { width: "125px" } };
const smallWidthStyle = { root: { width: "30%" } };
const bigWidthStyle = { root: { width: "70%" } };
const defaultCountryCodeInfo = phoneCodes.find(
  (codeInfo) => codeInfo.code === "TR"
)!;
const dropdownOptions: IComboBoxOption[] = phoneCodes.map((codeInfo) => ({
  key: codeInfo.code,
  text: codeInfo.dial_code + " ",
  title: codeInfo.name,
  data: codeInfo,
}));
